/**
 * state mặc định của module
 */
import commonFunction from "../../common/commonFunction";
export default {
    updateLayoutInfos(state, res) {
        if (!state.LayoutInfos) { state.LayoutInfos = {} }
        if (!res) { res = {} }
        state.LayoutInfos[`${res.Id}`] = res.Data;
    },
    resetLayoutInfo(state, res) {
        if (!res) return;
        if (!state.LayoutInfos) return;
        state.LayoutInfos[`${res}`] = {};
    },

    clearLayoutInfo(state, res) {
        state.LayoutInfos = {};
    }

};
